import { AnyAction } from '@reduxjs/toolkit'
import { Epic } from 'redux-observable'
import { of, from } from 'rxjs'
import { switchMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators'

import { fetchAgentDataSuccess, fetchAgentDataError, fetchAgentData } from './agent.reducer'

import { RootState } from '../../core/store/root.reducer'
import AgentService from '../services/agent.service'

export const fetchAgentDataEpic: Epic<
  AnyAction,
  AnyAction,
  RootState,
  { agentService: AgentService }
> = (action$, state$, { agentService }) =>
  action$.pipe(
    filter(fetchAgentData.match),
    withLatestFrom(state$),
    switchMap(() =>
      from(agentService.fetchAgentData()).pipe(
        map((result) => fetchAgentDataSuccess(result)),
        catchError((error: Error) =>
          of(fetchAgentDataError({ errorMessage: error.message, errorCode: '404' })),
        ),
      ),
    ),
  )

export default {
  fetchAgentDataEpic,
}
